import { TemplatesTab } from './components/templates/templatesTab';

export const SettingsTemplatesAutoReplyView = (): JSX.Element => {
  return (
    <TemplatesTab
      templateType="email_auto_reply"
      sectionTitle="All auto reply templates"
    />
  );
};
